import React, { useState } from 'react';
import './SideBar.css';
import { Link } from 'react-router-dom';

const SideBar: React.FC = () => {
  const [usersDropdownOpen, setUsersDropdownOpen] = useState(false);

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h3>Admin Panel</h3>
      </div>
      <ul className="sidebar-menu">
        <li>
          <Link to="/admin">
            <span className="icon">📊</span>
            Dashboard
          </Link>
        </li>
        <li className={`has-dropdown ${usersDropdownOpen ? 'active' : ''}`}>
          <div 
            className="dropdown-toggle" 
            onClick={() => setUsersDropdownOpen(!usersDropdownOpen)}
          >
            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
              <span className="icon">👥</span>
              <span>Χρήστες</span>
            </div>
            <span className="arrow">▶</span>
          </div>
          {usersDropdownOpen && (
            <ul className="submenu">
              <li><Link to="/admin/customers?role=customer">Πελάτες</Link></li>
              <li><Link to="/admin/customers?role=employee">Υπάλληλοι</Link></li>
              <li><Link to="/admin/customers?role=admin">Admin</Link></li>
              <li><Link to="/admin/customers">Όλοι</Link></li>
            </ul>
          )}
        </li>
        {/* <li>
          <Link to="/admin/products">
            <span className="icon">📦</span>
            Προϊόντα
          </Link>
        </li>
        <li>
          <Link to="/admin/orders">
            <span className="icon">🛒</span>
            Παραγγελίες
          </Link>
        </li> */}
        <li>
          <Link to="/admin/appointments">
            <span className="icon">📅</span>
            Ραντεβού
          </Link>
        </li>
        <li className="mt-auto">
          <Link to="/" className="return-link">
            <span className="icon">🏠</span>
            Επιστροφή στο Site
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SideBar;
